import React from "react";
import { ComponentWithAs, Icon, IconProps } from "@chakra-ui/react";

const IconComp: ComponentWithAs<"svg", IconProps> = ({
  children,
  ...props
}) => {
  return (
    <Icon {...props}>
      <path
        d="M496.393,61.679l-46.336-46.315c-20.096-20.117-55.211-20.16-75.413,0L45.79,344.218c-1.301,1.28-2.219,2.859-2.709,4.608
			L0.414,498.159c-1.067,3.733-0.043,7.744,2.709,10.475c2.027,2.027,4.757,3.115,7.552,3.115c0.981,0,1.963-0.128,2.944-0.405
			l149.333-42.667c1.728-0.491,3.328-1.429,4.608-2.709l328.832-328.832c10.069-10.091,15.616-23.488,15.616-37.717
			C512.009,85.167,506.462,71.77,496.393,61.679z M481.31,122.031L154.42,448.922L26.185,485.551l36.651-128.213L389.726,30.447
			c12.096-12.096,33.195-12.075,45.248,0l46.336,46.315C493.79,89.242,493.79,109.551,481.31,122.031z"
      />

      <path
        d="M496.393,61.679l-46.336-46.315c-20.096-20.117-55.211-20.16-75.413,0L45.812,344.218c-4.16,4.16-4.16,10.923,0,15.083
			c4.16,4.16,10.923,4.16,15.083,0L389.726,30.447c12.096-12.096,33.195-12.075,45.248,0l46.336,46.315
			c12.48,12.48,12.48,32.789,0,45.269L152.457,450.885c-4.16,4.16-4.16,10.923,0,15.083c2.091,2.069,4.821,3.115,7.552,3.115
			s5.461-1.045,7.552-3.115l328.832-328.853C517.193,116.314,517.193,82.479,496.393,61.679z"
      />

      <path
        d="M167.54,450.885L60.873,344.218c-4.16-4.16-10.923-4.16-15.083,0c-4.16,4.16-4.16,10.923,0,15.083l106.667,106.667
			c2.091,2.069,4.821,3.115,7.552,3.115s5.461-1.045,7.531-3.115C171.7,461.807,171.7,455.045,167.54,450.885z"
      />

      <path
        d="M444.873,66.885c-4.16-4.16-10.923-4.16-15.083,0L131.124,365.551c-4.16,4.16-4.16,10.923,0,15.083
			c2.091,2.069,4.821,3.115,7.552,3.115s5.461-1.045,7.531-3.115L444.873,81.967C449.033,77.807,449.033,71.044,444.873,66.885z"
      />
    </Icon>
  );
};
IconComp.defaultProps = {
  viewBox: "0 0 512.009 512.009",
  boxSize: "20px",
};

export default IconComp;
